import { createApp, getCurrentInstance } from 'vue/dist/vue.esm-bundler.js'
import getTranslation from './translations.js'

{
  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  const initialSearchDate = new Date();
  initialSearchDate.setDate(initialSearchDate.getDate() + 2);

  const appConfig = {
    props: {
      preferredLocationId: ''
    },
    data(){
      return {
        prettyErrorMessage: null,
        currentStep: "initialInfo",
        loading: true,
        guidPatients: [],
        selectedGuidPatient: null,
        availableStates: [],
        isNewPatient: null,
        existingPatientNextAvailableAppointment: null,
        availableAppointments: [],
        hasPresetLocation: false,

        // initial user info
        appointmentType: '',
        selectedLocation: null,
        patientAgeGroup: '',
        guardianFirstName: null,
        guardianLastName: null,
        patientFirstName: null,
        patientLastName: null,
        patientBirthMonth: null,
        patientBirthDay: null,
        patientBirthYear: null,
        patientEmail: null,
        patientPhoneNumber: null,

        // additional user info
        patientGender: null,
        patientAddress: null,
        patientCity: null,
        patientState: null,
        patientZip: null,
        insuranceType: null,
        otherInsuranceName: null,
        insuranceSubscriberFirstName: null,
        insuranceSubscriberLastName: null,
        insuranceSubscriberBirthMonth: null,
        insuranceSubscriberBirthDay: null,
        insuranceSubscriberBirthYear: null,
        insuranceMemberID: null,
        insuranceCompanyPhone: null,
        insuranceGroupNumber: null,

        // appointment search info
        searchAppointmentMonth: initialSearchDate.toLocaleString('en-US', { month: 'long' }),
        searchAppointmentDay: initialSearchDate.getDate(),
        searchAppointmentYear: initialSearchDate.getFullYear(),

        // selected appointment
        selectedAppointment: null,
      }
    },
    computed: {
      selectedLocationSupportsPatientAgeGroup(){
        if(this.selectedLocation && this.patientAgeGroup == 'child' && !this.selectedLocation.meta.adults){
          return false
        }
        return true
      },
      availableAppointmentDates() {
        const options = { weekday: "long", month: "short", day: "2-digit" };
        const dates = new Set(
          this.availableAppointments.map(a =>
            new Date(a.AppointmentStart).toLocaleDateString("en-US", options)
          )
        );
        return [...dates].slice(0, 3);
      },

      // birth date config
      daysInBirthMonth(){
        if (!this.patientBirthMonth) return [];
        let monthIndex = new Date(`${this.patientBirthMonth} 1, 2000`).getMonth() + 1;
        let year = this.patientBirthYear || new Date().getFullYear();
        let days = new Date(year, monthIndex, 0).getDate();
        return Array.from({ length: days }, (_, i) => i + 1);
      },
      availableBirthdayYears(){
        const year = new Date().getFullYear()
        const maxYearsBack = this.patientAgeGroup == "adult" ? 100 : 21
        let years = []
        let _i = this.patientAgeGroup == "adult" ? 21 : 0
  
        for(let i = _i; i < maxYearsBack; i++){
          years.push(year - i)
        }
        return years
      },

      // insurance bday config
      daysInBirthMonthInsurance(){
        if (!this.patientBirthMonth) return [];
        let monthIndex = new Date(`${this.insuranceSubscriberBirthMonth} 1, 2000`).getMonth() + 1;
        let year = this.insuranceSubscriberBirthYear || new Date().getFullYear();
        let days = new Date(year, monthIndex, 0).getDate();
        return Array.from({ length: days }, (_, i) => i + 1);
      },
      availableBirthdayYearsInsurance(){
        const year = new Date().getFullYear()
        const maxYearsBack = 100
        let years = []
        let _i = 10
  
        for(let i = _i; i < maxYearsBack; i++){
          years.push(year - i)
        }
        return years
      },


      patientAge() {
        if (!this.birthDate) return null;
        const birthDate = new Date(this.birthDate);
        const ageDiff = new Date() - birthDate;
        return Math.floor(ageDiff / (1000 * 60 * 60 * 24 * 365.25)); // Calculate age based on birth date
      },


      // search appointment config 
      availableSearchAppointmentYears(){
        const year = new Date().getFullYear()
        let years = ['']

        for(let i = 0; i < 2; i++){
          years.push(year + i)
        }

        return years
      },
      daysInSearchAppointmentMonth(){
        if (!this.searchAppointmentMonth) return [];
        let monthIndex = new Date(`${this.searchAppointmentMonth} 1, 2000`).getMonth() + 1;
        let year = this.searchAppointmentYear || new Date().getFullYear();
        let days = new Date(year, monthIndex, 0).getDate();
        return Array.from({ length: days }, (_, i) => i + 1);
      },
    },
    mounted(){
      this.hasPresetLocation = this.$refs.presetLocation?.value

      // step 1 get locations
      // then get states
      // then get GUID if needed or start
      this.fetchLocations(() => this.fetchStates(() => {
        const token = new URLSearchParams(location.search).get('token')
        if(token){
          this.loading = true
          fetch(this.$refs.adminAjaxUrl.value + "?action=fetch_mks_appointment_scheduler_by_token&token=" + token)
            .then(res => res.json())
            .then(json => {
              this.loading = false
              if(json?.success && json?.data?.matches){
                this.guidPatients = json.data.matches
                if(this.guidPatients.length > 1){
                  this.currentStep = 'guidSelectPatient'
                  this.scrollToTop()   
                } else {
                  this.setDataFromGuidPatient(this.guidPatients[0])
                }
              } else if(json?.data?.error_message) {
                alert(json.data.error_message)
              } else {
                console.error(json)
                alert("Something went wrong. Please try again later.")
              }
            })
            .catch(e => {
              this.loading = false
              console.error(e)
              alert("Something went wrong. Please try again later.")
            })
        } else {
          setTimeout(() => {
            let debug = new URLSearchParams(window.location.search).get('debug')
            if(debug){
              this.appointmentType = "cleaning"
              this.patientEmail = "ptran@benevis.com";
              this.patientAgeGroup = "child"
              this.guardianFirstName = "Mommy"
              this.guardianLastName = "Tooth"
              this.patientPhoneNumber = "6784519985"
              if(debug == 'ptran'){
                this.patientFirstName = "Ptran";
                this.patientLastName = "Tooth";
                this.patientBirthMonth = "February"
                this.patientBirthDay = 2
                this.patientBirthYear = 2020
              } else if(debug == 'ltran'){
                this.patientFirstName = "Ltran";
                this.patientLastName = "Tooth";
                this.patientBirthMonth = "January"
                this.patientBirthDay = 2
                this.patientBirthYear = 2018
              } else {
                this.patientFirstName = "firsty";
                this.patientLastName = "lasty";
                this.patientBirthMonth = "January"
                this.patientBirthDay = 1
                this.patientBirthYear = 2016
              }
            }
          }, 100)
        }
      }))
    },
    methods: {
      setDataFromGuidPatient(patient){
        // extract any information we can from the data and then continue as normal skipping the gather information step
        this.selectedGuidPatient = patient
        this.locations.forEach(location => {
          if(location.meta.crmfacilityid == patient.ClinicId){
            this.selectedLocation = location
          }
        })
        this.appointmentType = 'cleaning'
        this.patientAgeGroup = patient.IsAdult ? 'adult' : 'child'
        this.patientFirstName = patient.FirstName
        this.patientLastName = patient.LastName
        this.patientEmail = patient.EmailAddress
        this.patientPhoneNumber = patient.CellPhone
        this.currentStep = "selectAppointment"
        this.scrollToTop()
        this.setSearchAppointmentDateToMin()
        this.fetchAvailableAppointments()
      },
      fetchLocations(cb){
        fetch(this.$refs.adminAjaxUrl.value + "?action=fetch_mks_appointment_scheduler_locations")
          .then(res => res.json())
          .then(json => {
            this.loading = false
            if(json?.success && json?.data?.locations){
              this.locations = json.data.locations

              const el = this.$refs.adminAjaxUrl.closest('.appointment-scheduler-v2')
              if(el){
                const limitRaw = el.getAttribute('data-limit-locations')
                if(limitRaw.length){
                  const limitLocations = el.getAttribute('data-limit-locations').split(',').map(x => parseInt(x.trim()))
                  if(limitLocations.length){
                    this.locations = this.locations.filter(l => limitLocations.indexOf(l.ID) !== -1)
                  }
                }
              }

              if(this.$refs?.preferredLocation?.value){
                const found = this.locations.find(l => l.ID == this.$refs.preferredLocation.value)
                if(found){
                  this.selectedLocation = found
                }
              }

              const getParamLocation = new URLSearchParams(window.location.search).get('loc')
              if(getParamLocation){
                let found = this.locations.find(l => l?.meta?.crmfacilityid == getParamLocation)
                if(found){
                  this.selectedLocation = found
                } else {
                  found = this.locations.find(l => l?.ID == getParamLocation)
                  if(found){
                    this.selectedLocation = found
                  }
                }
              }

              if(this.$refs?.presetLocation?.value){
                let found = this.locations.find(l => l?.meta?.crmfacilityid == this.$refs.presetLocation.value)
                if(found){
                  this.selectedLocation = found
                } else {
                  found = this.locations.find(l => l?.ID == this.$refs.presetLocation.value)
                  if(found){
                    this.selectedLocation = found
                  }
                }
              }

              cb()

            } else if(json?.data?.error_message) {
              alert(json.data.error_message)
            } else {
              console.error(json)
              alert("Something went wrong. Please try again later.")
            }
          })
          .catch(e => {
            this.loading = false
            console.error(e)
            alert("Something went wrong. Please try again later.")
          })
      },
      fetchStates(cb){
        this.loading = true
        fetch(this.$refs.adminAjaxUrl.value + "?action=fetch_mks_appointment_scheduler_states")
          .then(res => res.json())
          .then(json => {
            this.loading = false
            if(json?.success && json?.data?.states){
              this.availableStates = json.data.states
              cb()
            } else if(json?.data?.error_message) {
              alert(json.data.error_message)
            } else {
              console.error(json)
              alert("Something went wrong. Please try again later.")
            }
          })
          .catch(e => {
            this.loading = false
            console.error(e)
            alert("Something went wrong. Please try again later.")
          })
      },
      translate(str){
        return getTranslation(str)
      },
      scrollToTop(){
        setTimeout(() => {
          document.querySelectorAll('[data-action="adminVariableContent"]').forEach(el => {
            let content = el.innerHTML; 
            content = content.replace(/{patient name}/g, this.patientFirstName + " " + this.patientLastName)
            content = content.replace(/{patient email}/g, this.patientEmail)

            if(this.selectedLocation?.meta?.location?.address){
              content = content.replace(/{location address}/g, this.selectedLocation?.meta?.location?.address)
            }
            if(this.selectedAppointment){
              content = content.replace(/{appointment date}/g, this.formatDate(this.selectedAppointment.AppointmentStart))
            }
            if(this.selectedAppointment){
              content = content.replace(/{appointment time}/g, this.formatTime(this.selectedAppointment.AppointmentStart))
            }
            el.innerHTML = content;
          });

          setTimeout(() => {
            const top = document.querySelector('.main-header').offsetHeight + document.querySelector('.appointment-scheduler-v2').offsetTop
            window.scrollTo({ top: top + 'px', behavior: 'smooth' });
          })
        });
      },
      handleLocationChange(){
        this.currentStep = "selectAppointment"
        this.scrollToTop()
        this.setSearchAppointmentDateToMin()
        this.fetchAvailableAppointments()
      },
      checkPatientInfo(){
        if(this.handleFormErrors()){
          return
        }

        this.loading = true
        
        const formData = Object.fromEntries(new FormData(this.$refs.step1Form).entries());

        fetch(this.$refs.adminAjaxUrl.value + "?action=mks_appointment_scheduler_check_patient_info", {
          method: 'POST',
          body: JSON.stringify(formData)
        })
          .then(res => res.json())
          .then(json => {
            this.loading = false
            if(json?.success){
              // there are 3 cases here:
              // - existing patient's next_available_appointment is >= 6 months in the future
              //   - (stop the process)
              // - existing patient's next_available_appointment is <= 6 months in the future 
              //   - (set the minimum allowed appointment date)
              //   - (skip the additional info step and go to select appointment)
              // - new patient 
              //   -(gether additional info)
              if(json?.data?.is_existing_patient){
                if(json?.data?.next_appointment_diff?.months >= 6){
                  this.currentStep = "existingPatientHasAppointment"
                  this.scrollToTop()
                } else {
                  this.isNewPatient = false
                  // adding the TIME here so JS doesn't try to ajust time for timezone...
                  this.existingPatientNextAvailableAppointment = new Date(json?.data?.next_available_appointment + "T00:00:00")
                  this.currentStep = "selectAppointment"
                  this.setSearchAppointmentDateToMin()
                  this.fetchAvailableAppointments()
                  this.scrollToTop()
                }
              } else {
                this.isNewPatient = true
                this.currentStep = "additionalInfo"
                this.scrollToTop()
              }
            } else {
              console.error(json)
              alert(json?.data?.error_message || "Something went wrong. Please try again later. Error code: 1")
            }
          })
          .catch(e => {
            this.loading = false
            console.error(e)
            alert("Something went wrong. Please try again later. Error code: 2")
          })
      },
      getMinSearchAppointmentDate(){
        const diffDays = (date1, date2) => Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
        const today = new Date();
        let minDate = new Date();
        const isTexasBaby = this.patientState == "TX" && this.patientAge < 3
        const isNewCommercialPatient = this.isNewPatient && !(this.insuranceType.includes('edicaid') || this.insuranceType.includes('SCHIP'))

        if (!this.isNewPatient && this.existingPatientNextAvailableAppointment) {
          if(this.existingPatientNextAvailableAppointment.withoutTime() > minDate.withoutTime()){
            minDate = this.existingPatientNextAvailableAppointment
          }
        }

        if (isTexasBaby) {
          // state is texas and age is < 3
          // ensure the minimum is at least 91 days out
          const daysOut = diffDays(today, minDate);
          if (daysOut < 91) {
            minDate.setDate(minDate.getDate() + (91 - daysOut));
          }
        } else if (isNewCommercialPatient) {
          // new commercial patient (everything besides medicaid and CHIP)
          // ensure the minimum is at least 3 days out
          const daysOut = diffDays(today, minDate);
          if (daysOut < 3) {
            minDate.setDate(minDate.getDate() + (3 - daysOut));
          }
        }

        // ensure the minimum is at least 2 days out
        const daysOut = diffDays(today, minDate);
        if (daysOut < 2) {
          minDate.setDate(minDate.getDate() + (2 - daysOut));
        }

        // if min date is sunday -- push forward one -- always do this 
        if (minDate.getDay() === 0){
          minDate.setDate(minDate.getDate() + 1)
        }

        return minDate
      },
      checkDateShouldBeDisabled(day){
        const today = new Date();
        const selectedMonthIndex = new Date(`${this.searchAppointmentMonth} 1, 2000`).getMonth();
        const selectedYear = this.searchAppointmentYear || today.getFullYear();
        const selectedDate = new Date(selectedYear, selectedMonthIndex, day);
        if (selectedDate.getDay() === 0) return true; // Ignore Sundays
        const minDate = this.getMinSearchAppointmentDate()
        return selectedDate.withoutTime() < minDate.withoutTime(); // Disable if before min required date
      },
      handleFormErrors(){
        let preventSubmit = false

        // Check patient phone number
        if (this.$refs.patientPhoneNumber) {
          const patientPhoneValue = this.$refs.patientPhoneNumber.value.replace(/\D/g, '');
          if (patientPhoneValue.length !== 10) {
            alert(this.translate("please-match-phone-format"));
            this.$refs.patientPhoneNumber.focus();
            preventSubmit = true;
          }
        }

        // Check insurance company phone number
        if (this.$refs.insuranceCompanyPhone) {
          const insurancePhoneValue = this.$refs.insuranceCompanyPhone.value.replace(/\D/g, '');
          if (insurancePhoneValue.length !== 10) {
            alert(this.translate("please-match-phone-format"));
            this.$refs.insuranceCompanyPhone.focus();
            preventSubmit = true;
          }
        }

        return preventSubmit
      },
      submitAdditionalInfo(){
        if(this.handleFormErrors()){
          return
        }

        this.currentStep = 'selectAppointment'
        this.scrollToTop()
        this.setSearchAppointmentDateToMin()
        this.fetchAvailableAppointments()
      },
      setSearchAppointmentDateToMin(){
        const minDate = this.getMinSearchAppointmentDate()
        this.searchAppointmentYear = minDate.getFullYear()
        this.searchAppointmentMonth = minDate.toLocaleString('default', { month: 'long' })
        this.searchAppointmentDay = minDate.getDate()
      },
      fetchAvailableAppointments(){
        this.loading = true
        fetch(this.$refs.adminAjaxUrl.value + "?action=mks_appointment_scheduler_fetch_available_times", {
          method: 'POST',
          body: JSON.stringify({
            // patientId: this.existingPatient,
            locationId: this.selectedLocation.meta.crmfacilityid,
            isAdult: this.patientAgeGroup == "adult",
            year: this.searchAppointmentYear,
            month: this.searchAppointmentMonth,
            day: this.searchAppointmentDay
          })
        })
          .then(res => res.json())
          .then(json => {
            this.loading = false
            if(json?.success && json?.data?.available_appointments){
              this.availableAppointments = json.data.available_appointments
            } else if(json?.data?.error_message) {
              alert(json.data.error_message)
            } else {
              console.error(json)
              alert("Something went wrong. Please try again later.")
            }
          })
          .catch(e => {
            this.loading = false
            console.error(e)
            alert("Something went wrong. Please try again later.")
          })
      },
      selectAppointment(appointment){
        this.selectedAppointment = appointment
        this.currentStep = "reviewDetails"
        this.scrollToTop()
      },
      submitAppointment(){
        this.loading = true
        fetch(this.$refs.adminAjaxUrl.value + "?action=mks_appointment_scheduler_submit_appointment", {
          method: 'POST',
          body: JSON.stringify({
            guid: new URLSearchParams(window.location.search).get('token'),
            appointmentType: this.appointmentType,
            selectedLocation: this.selectedLocation,
            selectedGuidPatient: this.selectedGuidPatient,
            patientAgeGroup: this.patientAgeGroup,
            guardianFirstName: this.guardianFirstName,
            guardianLastName: this.guardianLastName,
            patientFirstName: this.patientFirstName,
            patientLastName: this.patientLastName,
            patientBirthDay: this.patientBirthMonth ? new Date(`${this.patientBirthMonth} ${this.patientBirthDay} ${this.patientBirthYear}`).toISOString().split('T')[0] : null,
            patientEmail: this.patientEmail,
            patientPhoneNumber: this.patientPhoneNumber ? this.patientPhoneNumber.replace(/\D/g, '') : '',
            patientGender: this.patientGender,
            patientAddress: this.patientAddress,
            patientCity: this.patientCity,
            patientState: this.patientState,
            patientZip: this.patientZip,
            insuranceType: this.insuranceType,
            otherInsuranceName: this.otherInsuranceName,
            insuranceSubscriberFirstName: this.insuranceSubscriberFirstName,
            insuranceSubscriberLastName: this.insuranceSubscriberLastName,
            insuranceSubscriberDOB: this.insuranceSubscriberBirthMonth ? new Date(`${this.insuranceSubscriberBirthMonth} ${this.insuranceSubscriberBirthDay} ${this.insuranceSubscriberBirthYear}`).toISOString().split('T')[0] : null,
            insuranceMemberID: this.insuranceMemberID,
            insuranceCompanyPhone: this.insuranceCompanyPhone ? this.insuranceCompanyPhone.replace(/\D/g, '') : '',
            insuranceGroupNumber: this.insuranceGroupNumber,
            selectedAppointment: this.selectedAppointment,
          })
        })
          .then(res => res.json())
          .then(json => {
            this.loading = false
            if(json?.success){
              this.currentStep = "confirmation"
              this.scrollToTop()
            } else if(json?.data?.error_message) {
              alert(json.data.error_message)
            } else if(json?.data?.pretty_error_message){
              this.currentStep = 'prettyErrorMessage'
              this.prettyErrorMessage = json.data.pretty_error_message
              this.scrollToTop()
            } else {
              console.error(json)
              alert("Something went wrong. Please try again later.")
            }
          })
          .catch(e => {
            this.loading = false
            console.error(e)
            alert("Something went wrong. Please try again later.")
          })
      },
      filteredAppointments(date) {
        return this.availableAppointments.filter(a => {
          const options = { weekday: "long", month: "short", day: "2-digit" };
          return new Date(a.AppointmentStart).toLocaleDateString("en-US", options) === date;
        });
      },
      formatTime(datetime) {
        return new Date(datetime).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true
        });
      },
      formatDate(datetime) {
        return new Date(datetime).toLocaleDateString("en-US", {
          weekday: "long",
          month: "short",
          day: "numeric"
        });
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.appointment-scheduler-v2')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}